module.exports = __webpack_public_path__ + "img/3-7-IMG_3001.99ac7f51.png";